import { Navigate, useLocation } from 'react-router-dom';

/** An old path (e.g. /safety-calculator) kept working: same query and hash, new path. */
export function RenamedRoute({ to }: { to: string }) {
  const { search, hash } = useLocation();
  return <Navigate to={`${to}${search}${hash}`} replace />;
}
